<div mat-dialog-title class="ds">
  <span>{{ title }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
<div id="formContainer" mat-dialog-content class="content ds">
  @if (!element.isEmailOnly) {
    <div id="orderCompletedMessageContainer" class="text-container">
      @if (element.details && element.details.quoteNumber) {
        <typography variant="mat-body-1" weight="regular">
          {{appStrings.quote_printExportEmailLabelQuote}}<b>{{element.details.quoteNumber}}{{appStrings.quote_rVersion}}{{element.details.version}}</b>{{appStrings.quote_printExportEmailLabelCreated}}
        </typography>
      }
      @if (element.isOrder) {
        <typography variant="mat-body-1" weight="regular">
          {{appStrings.order_printExportEmailOptionsLabel}}
        </typography>
      }
      @if (!element.details) {
        <typography variant="mat-body-1" weight="regular">
          {{appStrings.quote_printExportEmail}}
        </typography>
      }
    </div>
  }
  <form [formGroup]="form">
    <div id="emailForm" class="form-container" [class.form-container--with-header]="!element.isEmailOnly">
      <div class="autoComplt withChips ds vertical-label fill-width no-subscript">
        <mat-label class="autocomplete-label">{{ appStrings.quote_complete_emailAddressesLabel }}<span class="required-asterisk">*</span></mat-label>
        <div class="container-relative">
          <mat-form-field>
            <mat-chip-grid #chipGrid [attr.aria-label]="appStrings.quote_complete_emailAddressesLabel">
              @for (email of emailChips; track email) {
                <mat-chip-row (removed)="removeChip(email)">
                  {{ email }}
                  <button matChipRemove [attr.aria-label]="'Remove ' + email">
                    <mat-icon class="clear-icon">cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              <input #chipInput
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addChip($event)"
                [matAutocomplete]="emailAuto"
                [formControl]="chipInputControl" />
            </mat-chip-grid>
            <mat-autocomplete #emailAuto="matAutocomplete" class="ds" (optionSelected)="selectFromAutocomplete($event)">
              @for (option of (filteredOptions | async) ?? []; track option.value) {
                <mat-option [value]="option">{{ option.label }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      @if (hasEnsEmails || hasContactEmails) {
        <div class="email-quick-actions">
          @if (hasEnsEmails) {
            <ds-button id="addRecipientsButton" variant="label-only" size="medium" type="primary"
              (onClick)="addRecipients()" [label]="appStrings.button_addRecipient"
              [isDisabled]="allRecipientsAdded">
            </ds-button>
          }
          @if (hasContactEmails) {
            <ds-button id="addContactButton" variant="label-only" size="medium" type="primary"
              (onClick)="addAllContacts()" [label]="appStrings.button_addContact"
              [isDisabled]="allContactsAdded">
            </ds-button>
          }
        </div>
      }
    </div>
  </form>
</div>
<div id="dialog-actions" mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @if (!element.isEmailOnly) {
      <ds-button id="exportButton" variant="label-only" size="medium" type="secondary" (onClick)="exportQuote()" [label]="appStrings.button_export">
      </ds-button>
    }
    @if (!element.isEmailOnly) {
      <ds-button id="printButton" variant="label-only" size="medium" type="secondary" (onClick)="printQuote()" [label]="appStrings.button_print">
      </ds-button>
    }
    @if (element.isEmailOnly) {
      <ds-button id="closeButton" variant="label-only" size="medium" type="secondary" (onClick)="close()" [label]="appStrings.button_close">
      </ds-button>
    }
    <ds-button id="addButton" variant="label-only" size="medium" type="primary" (onClick)="emailQuote()" [label]="appStrings.button_email" [isDisabled]="isEmailButtonDisabled">
    </ds-button>
  </div>
</div>